var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b,.c{fill:none;}.b{stroke:#707070;stroke-linecap:square;}.d,.e{stroke:none;}.e{fill:#707070;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10378 -459)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    rx: 11,
    transform: "translate(-10378 459)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10374.409 463.009)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.127)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-6.6-124.519c.5-.223,1.1-.512,1.1-.512a4.168,4.168,0,0,0,1.968-2.742,4.762,4.762,0,0,0,.249-1.8,1.407,1.407,0,0,1,1.365-.42s1.6,1.574.525,4.513a14.848,14.848,0,0,1,4.08.262,1.051,1.051,0,0,1,.525,1.017,1.674,1.674,0,0,1-.354,1.1s.767.164.77,1.426a1.433,1.433,0,0,1-.862,1.448,1.168,1.168,0,0,1,.39,1.2,1.049,1.049,0,0,1-.744.951A1.58,1.58,0,0,1,1.6-116.32a24.963,24.963,0,0,1-5.207.22c-.494-.044-2.317-.172-3.071-.863a1.085,1.085,0,0,1-.382-.813c0-.24,0-5.95,0-5.95a.9.9,0,0,1,.461-.794",
    transform: "translate(7.062 130.021)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.903)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(85.129 16.062)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-79.566-8.3a1.049,1.049,0,0,1-1.05,1.05h-3.464a1.05,1.05,0,0,1-1.05-1.05v-6.717a1.05,1.05,0,0,1,1.05-1.05h3.464a1.05,1.05,0,0,1,1.05,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M -80.61581420898438 -8.245442390441895 C -80.58847045898438 -8.245442390441895 -80.56623077392578 -8.267683029174805 -80.56623077392578 -8.295012474060059 L -80.56623077392578 -15.01236248016357 C -80.56623077392578 -15.03973293304443 -80.58847045898438 -15.06200313568115 -80.61581420898438 -15.06200313568115 L -84.07935333251953 -15.06200313568115 C -84.10672760009766 -15.06200313568115 -84.12899780273438 -15.03973293304443 -84.12899780273438 -15.01236248016357 L -84.12899780273438 -8.295012474060059 C -84.12899780273438 -8.267683029174805 -84.10672760009766 -8.245442390441895 -84.07935333251953 -8.245442390441895 L -80.61581420898438 -8.245442390441895 M -80.61581420898438 -7.245442867279053 L -84.07935333251953 -7.245442867279053 C -84.65910339355469 -7.245442867279053 -85.12899780273438 -7.715342998504639 -85.12899780273438 -8.295012474060059 L -85.12899780273438 -15.01236248016357 C -85.12899780273438 -15.59204292297363 -84.65910339355469 -16.06200218200684 -84.07935333251953 -16.06200218200684 L -80.61581420898438 -16.06200218200684 C -80.03598785400391 -16.06200218200684 -79.56623077392578 -15.59204292297363 -79.56623077392578 -15.01236248016357 L -79.56623077392578 -8.295012474060059 C -79.56623077392578 -7.715342998504639 -80.03598785400391 -7.245442867279053 -80.61581420898438 -7.245442867279053 Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeDefault);
export default __webpack_public_path__ + "static/media/like-default.7f83719b6ade73d10675c5405b236a15.svg";
export { ForwardRef as ReactComponent };